import React from 'react';
import { Users, UserPlus, ChevronRight } from 'lucide-react';

const FriendsView = ({ friends, onOpenChat, onOpenPairing, onSelectFriend, friendStatuses }) => {
    const isOnline = (lastActive) => {
        if (!lastActive) return false;
        const now = new Date();
        const activeTime = lastActive.toDate ? lastActive.toDate() : new Date(lastActive);
        const diffInMinutes = (now - activeTime) / (1000 * 60);
        return diffInMinutes < 2; // Online if active in last 2 mins
    };

    return (
        <div className="flex-1 overflow-y-auto p-4 pb-20 min-h-0">
            {/* Add Companion Button */}
            <button
                onClick={onOpenPairing}
                className="w-full mb-4 py-3 rounded-xl border-2 border-dashed border-gray-600 hover:border-neon-cyan text-gray-500 hover:text-neon-cyan flex items-center justify-center gap-2 transition-all"
            >
                <UserPlus size={18} />
                <span className="text-sm font-bold">Link Non-Striker (QR)</span>
            </button>

            <h3 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-3">Your Companions</h3>
            {friends.length === 0 ? (
                <div className="text-center py-10">
                    <Users size={40} className="mx-auto text-gray-700 mb-3" />
                    <p className="text-gray-500 text-sm">No companions yet.</p>
                    <p className="text-gray-600 text-xs mt-1">Search for players and send a friend request!</p>
                </div>
            ) : (
                <div className="space-y-2">
                    {friends.map(friend => {
                        const online = isOnline(friendStatuses?.[friend.uid]);
                        return (
                            <div
                                key={friend.uid}
                                onClick={() => onSelectFriend(friend)} // Open Profile Modal
                                className="bg-gray-800 p-4 rounded-xl border border-gray-700 flex items-center gap-4 hover:border-neon-cyan/50 transition cursor-pointer active:scale-[0.98]"
                            >
                                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center font-bold text-lg relative">
                                    {friend.displayName?.charAt(0) || '?'}
                                    {/* Online indicator */}
                                    <div className={`absolute bottom-0 right-0 w-3 h-3 ${online ? 'bg-green-500' : 'bg-gray-600'} rounded-full border-2 border-gray-800 transition-colors`}></div>
                                </div>
                                <div className="flex-1">
                                    <h4 className="text-white font-bold">{friend.displayName}</h4>
                                    <span className="text-xs text-gray-500">
                                        {online ? 'Online' : 'Offline'}
                                    </span>
                                </div>
                                <ChevronRight size={18} className="text-gray-600" />
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default FriendsView;
